import React, { useState} from "react";
// import MediaQuery from "react-responsive";
import { InlineMath } from "react-katex";
import Cgs from "./Cgs";
import Ch2 from "./Ch2";
import "../Programlinear/1/Part1.css"
// import Carags from "./carags.mp4"
// import Dialog from "@material-ui/core/Dialog";
// import Button from '@material-ui/core/Button';
// import DialogActions from '@material-ui/core/DialogActions';
// import DialogContent from '@material-ui/core/DialogContent';
// import DialogTitle from '@material-ui/core/DialogTitle';
// import VideoPlayer from "react-video-js-player";
const Part3 = () => {
	const [ukuranH,setUkuranH]=useState(19)
	const [ukuranP,setUkuranP]=useState(15)
	const sizeplus =()=>{
		setUkuranH(ukuranH+1)
		setUkuranP(ukuranP+1)
	}
	const sizemin =()=>{
		setUkuranH(ukuranH-1)
		setUkuranP(ukuranP-1)
	}
	const [chsoal0, setChsoal0] = useState(false);
	const clickSetChSoal0 = () => setChsoal0(!chsoal0);
    const [chsoal2, setChsoal2] = useState(false);
	const clickSetChSoal2 = () => setChsoal2(!chsoal2);
	
	return (
		<div className="container">
		<div className="d-flex justify-content-end">
		<button className="btnplus" onClick={sizeplus}><h6>A<sub>+</sub></h6></button>
		<button className="btnplus" onClick={sizemin}><h6>A<sub>-</sub></h6></button>
		</div>	
			<div
				style={{
					marginTop: "1.5rem",
					color: "#2d8659",
				}}
			>
				<h5 style={{fontSize:`${ukuranH}px`}}>B. Metode Garis Selidik</h5>
			</div>
			<div
				style={{
					textIndent: "2rem",
					width: "100%",
					textAlign: "justify",
					lineHeight: "35px",
					fontSize:`${ukuranP}px`
				}}
				className="col-sm-12 mt-3"
			>
				<p>Setelah mempelejari mencari nilai optimum dengan metode uji titik pojok, Maka pada pembahasan kali ini kalian akan mempeljarai penyelesaian program linear dengan cara selanjutnya ialah menggunakan metode garis selidik. Coba kalian baca dan pahami dulu uraian di bawah sebelum ke contoh soal dan latihan soal!</p>
				<p>
					Garis selidik adalah garis yang sejajar dengan fungsi objektif. Jika fungsi objektifnya adalah <InlineMath math="Z= f(x,y)= ax + by"/>, maka garis selidiknya adalah <InlineMath math="ax + by = c"/>. 
					Langkah pertama, dengan menggambarkan garis selidik awal dengan mengambil <InlineMath math="c = 0"/>. Untuk menentukan titik koordinat yang optimum, kalian menggeser garis selidik awal secara sejajar sampai mempotong setiap titik koordinat yang memenuhi daerah penyelesaian dari fungsi-fungsi kendalanya.
					{/* Ingat bahwa fungsi objektif dituliskan <b>f(x,y)= ax + by</b> atau{" "}
					<b>z = ax + by</b>. Dengan menggunakan metode garis selidik, maka
					garis selidik dapat didefiniskan Sebagai <b>ax + by = k</b>. Garis ini
					berfugsi untuk menyelidiki dan menentukan sampai sejauh mana fungsi
					objektif z maksimum atau minimum. */}
				</p>
			</div>
			<div
				style={{
					textIndent: "2rem",
					width: "100%",
					textAlign: "justify",
					lineHeight: "35px",
				}}
				className="col-sm-12 mt-3"
			>
				<p style={{fontSize:`${ukuranP}px`}}>
					Adapun aturan-aturan dalam penggunaan garis selidik <b>ax + by = c</b>
					.
				</p>
			</div>
			<div
				style={{
					width: "100%",
					textAlign: "justify",
					lineHeight: "35px",
				}}
				className="col-sm-12 mt-3"
			>
				<ol style={{fontSize:`${ukuranP}px`}}>
					<li>
						Lukis garis <i>ax + by = c</i> yang memotong sumbu <i>x</i> dan{" "}
						<i>y</i>
					</li>
					<li>
						Tarik garis-garis sejajar dengan <i>ax + by = c</i> hingga nilai{" "}
						<i>c</i> maksimum atau minimum. Namun perhatikan hal-hal berikut:{" "}
					</li>
                    <p><ul>
                    <li>Titik koordinat yang paling jauh dipotong oleh garis selidik menunjukkan nilai maksimum fungsi objektifnya. Titik koordinat yang paling jauh biasanya posisinya paling kanan atas.</li>
                    <li>Sedangkan titik koordinat yang paling dekat dipotong oleh garis selidik menunjukkan nilai minimum fungsi objektif. Titik koordinat yang paling dekat biasanya titik pojok yang posisinya paling kiri bawah.</li>
                    </ul></p>
					<p>Untuk lebih jelasnya, coba kalian langsung ke contoh soal.</p>
				</ol>
			</div>

			<div className="d-grid gap-2">
				<button
					onClick={() => clickSetChSoal0()}
					className="btn btn-outline-success border-success shadow rounded"
				>
					{" "}
					<h6
						style={{
							animation: "scrollTop 0.3s alternate ease infinite",
						}}
					>
						Contoh Soal
					</h6>
				</button>
			</div>
			{chsoal0 ? 
			<Cgs ukuranH={ukuranH} ukuranP={ukuranP} />
			:null}
			<p style={{fontSize:`${ukuranP}px`}} className="text-center mt-2 mb-2">Setelah membaca dan memahami contoh soal di atas, selanjutnya kerjakan latihan di bawah ini !</p>
			<div className="row">
				<div className="col">
					<div
						className="card mt-2 mb-2 border-success"
						style={{ borderRadius: "20px" }}
					>
						<div
							style={{ backgroundColor: "#40bf80", borderRadius: "20px" }}
							className="card-header"
						>
							<h6 style={{fontSize:`${ukuranH}px`}} className="text-white text-center">Petunjuk Pengerjaan</h6>
						</div>
						<div className="card-body">
							<ol style={{fontSize:`${ukuranP}px`}}>
								<li>Perhatikan dengan teliti !</li>
								<li>Kalian harus mengisi form yang kosong</li>
								<li>Apabila benar maka border form akan berwarna hijau, kemudian akan tampil lanjutannya</li>
								<li>Apabila salah maka border form akan berwarna merah</li>
							</ol>
						</div>
					</div>
				</div>
			</div>
            <div className="d-grid gap-2">
				<button
					onClick={() => clickSetChSoal2()}
					className="btn btn-outline-success border-success shadow rounded"
				>
					{" "}
					<h6
						style={{
							animation: "scrollTop 0.3s alternate ease infinite",
						}}
					>
						Latihan Soal
					</h6>
				</button>
			</div>
            {chsoal2 ? 
                <Ch2 ukuranH={ukuranH} ukuranP={ukuranP} />
            :null}
            
		</div>
	);
};

export default Part3;
